import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {computed, makeObservable, observable} from "mobx";
import {AbstractModel} from "./abstract-model";

export interface ProjectMunicipalityProps {
    objectId?: number;
    projectId?: number;
    bfsNr?: number;
}

@JsonObject()
export class ProjectMunicipality extends AbstractModel {
    static readonly comparableAttributes: string[] = [
        "projectId", "bfsNr"
    ];
    // workaround, because feature template doesn't seem to work for table features
    static readonly prototypeAttributes: string[] = [
        "OBJECTID", "PROJ_ID", "BFS_NR","CREATED_USER", "CREATED_AT", "UPDATED_USER", "UPDATED_AT"
    ];
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "OBJECTID"],
        ["projectId", "PROJ_ID"],
        ["bfsNr", "BFS_NR"]
    ]);

    class = "ProjectMunicipality";
    typeLabel = "Gemeinde Projekt";

    /**
     * !!! Use BFS Nr as guid !!!
     */
    @JsonProperty({name: "BFS_NR"})
        guid: string;

    /**
     * Projektschlüssel des zugehörigen Projekts
     */
    @JsonProperty({name: "PROJ_ID"})
        projectId: number;

    /**
     * Schlüssel der zugehörigen Gemeinde
     */
    @JsonProperty({name: "BFS_NR"})
        bfsNr: number;

    constructor(props?: ProjectMunicipalityProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,
            projectId: observable,
            bfsNr: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return ProjectMunicipality.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }
}
